import { routeTitle } from "./routeName";

// Слой «Покрытие троп маршрутами»: по клику на линии - список маршрутов,
// проходящих в этом месте. queryRenderedFeatures возвращает объект по разу на
// каждый тайл, через который проходит линия, - отсюда дедупликация по id.
export const uniqueRoutesAt = (features: Array<{ properties?: Record<string, unknown> | null }>) => {
  const byId = new Map<number, string>();
  for (const feature of features) {
    const id = feature.properties?.id;
    if (typeof id !== "number" || byId.has(id)) continue;
    byId.set(id, routeTitle(String(feature.properties?.name ?? "")));
  }
  return [...byId].map(([id, title]) => ({ id, title })).sort((a, b) => a.title.localeCompare(b.title, "ru"));
};

const escape = (s: string) =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");

// Значки lucide (24x24, обводка currentColor) - попап рисуется вне Vue.
const svg = (inner: string, cls: string) =>
  `<svg class="${cls}" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${inner}</svg>`;
const ICON = {
  route: '<circle cx="6" cy="19" r="3"/><path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"/><circle cx="18" cy="5" r="3"/>',
  ruler: '<path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/>',
  gain: '<polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/>',
  clock: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
  chevron: '<path d="m9 18 6-6-6-6"/>',
};

export interface CoverageRoute {
  id: number;
  title: string;
  // Необязательные базовые данные (из каталога маршрутов, если он загружен).
  accent?: string;
  distance?: string;
  gain?: string;
  time?: string;
}

// Разметка попапа MapLibre (вне Vue): заголовок со счётчиком и карточки-кнопки
// маршрутов (цветная полоска сложности, название, дистанция/набор/время).
// id - в data-route-id, клики ловит делегированный обработчик в useRouteCoverage.ts.
export const coveragePopupHtml = (routes: CoverageRoute[], labels: { title: string; open: string }) => `
  <div class="coverage-popup">
    <p class="coverage-popup__title">${svg(ICON.route, "coverage-popup__title-icon")}<span>${escape(labels.title)}</span><span class="coverage-popup__count">${routes.length}</span></p>
    <ul class="coverage-popup__list">
      ${routes
        .map((r) => {
          const meta = [
            r.distance ? `<span class="coverage-popup__meta-item">${svg(ICON.ruler, "coverage-popup__meta-icon")}${escape(r.distance)}</span>` : "",
            r.gain ? `<span class="coverage-popup__meta-item">${svg(ICON.gain, "coverage-popup__meta-icon")}${escape(r.gain)}</span>` : "",
            r.time ? `<span class="coverage-popup__meta-item">${svg(ICON.clock, "coverage-popup__meta-icon")}${escape(r.time)}</span>` : "",
          ].join("");
          const accent = r.accent ? ` style="--coverage-accent:${escape(r.accent)}"` : "";
          return `<li><button type="button" class="coverage-popup__item" data-route-id="${r.id}"${accent} aria-label="${escape(labels.open)}: ${escape(r.title)}">
            <span class="coverage-popup__bar" aria-hidden="true"></span>
            <span class="coverage-popup__body"><span class="coverage-popup__name">${escape(r.title)}</span>${meta ? `<span class="coverage-popup__meta">${meta}</span>` : ""}</span>
            ${svg(ICON.chevron, "coverage-popup__chevron")}
          </button></li>`;
        })
        .join("")}
    </ul>
  </div>`;
